import CheckIcon from '@mui/icons-material/Check';
import PauseIcon from '@mui/icons-material/Pause';
import { AutomationStatus } from '@prisma/client';
import Badge from '../../global/Badge';

interface Props {
  status: AutomationStatus;
}

function AutomationBadge({ status }: Props) {
  const isActive = status === 'ACTIVE';
  return (
    <Badge
      colorScheme={isActive ? 'secondary' : 'warning'}
      icon={isActive ? CheckIcon : PauseIcon}
      text={isActive ? 'Active' : 'Paused'}
      sx={{ width: 'fit-content' }}
    />
  );
}

export default AutomationBadge;
